import { boolean, email, firstName, id, lastName, pastDate } from '@gonfalon/mocks/common';
import { createMockResourceBuilder } from '@gonfalon/mocks/createMockResourceBuilder';
import type { Member, schemas } from '@gonfalon/openapi/types';

type MemberTeamSummaryRep = schemas['MemberTeamSummaryRep'];
type RoleAttributes = schemas['RoleAttributeMap'];

export const mockMember = createMockResourceBuilder(
  (): Member => ({
    _id: id(),
    _lastSeen: pastDate(),
    _links: {},
    _pendingInvite: boolean(),
    _verified: boolean(),
    creationDate: pastDate(),
    customRoles: [],
    email: email(),
    firstName: firstName(),
    lastName: lastName(),
    role: '',
    mfa: '',
  }),
  {
    withCustomRoles: (customRoles: string[]) => (draft) => {
      draft.customRoles = customRoles;
    },
    withBaseRole: (baseRole: 'admin' | 'reader' | 'writer' | 'no_access') => (draft) => {
      draft.role = baseRole;
    },
    withRoleAttributes: (roleAttributes: RoleAttributes) => (draft) => {
      draft.roleAttributes = roleAttributes;
    },
    withTeams: (teamSummaryReps: MemberTeamSummaryRep[]) => (draft) => {
      draft.teams = teamSummaryReps;
    },
  },
);
